// src/Components/CreateNFT.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CreateNFT = ({ onCreateNFT }) => {
  const [nftData, setNftData] = useState({
    title: '',
    description: '',
    price: '',
    category: 'Artwork',
    rarity: 'common'
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNftData({
      ...nftData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      // Create a simple mock NFT
      const newNFT = {
        id: Date.now(), // Generate a unique ID
        title: nftData.title,
        description: nftData.description,
        price: parseFloat(nftData.price),
        category: nftData.category,
        rarity: nftData.rarity,
        image: '/api/placeholder/400/400',
        creator: {
          id: 2, // Mock user ID
          name: 'Admin User',
          avatar: '/api/placeholder/40/40'
        },
        likes: 0,
        views: 0,
        created: new Date().toISOString().split('T')[0]
      };
      
      console.log('Created new NFT:', newNFT);
      
      // Call the callback to update App's state
      if (onCreateNFT) {
        onCreateNFT(newNFT);
        navigate(`/nft/${newNFT.id}`);
      } else {
        setError('Failed to create NFT: internal error');
        console.error('onCreateNFT function not provided');
      }
    } catch (error) {
      setError('Failed to create NFT: ' + (error.message || 'Unknown error'));
      console.error('Error creating NFT:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="create-nft-container">
      <h2>Create New NFT</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit} className="create-nft-form">
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={nftData.title}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={nftData.description}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="price">Price (ETH)</label>
          <input
            type="number"
            step="0.01"
            id="price"
            name="price"
            value={nftData.price}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="category">Category</label>
          <select
            id="category"
            name="category"
            value={nftData.category}
            onChange={handleInputChange}
          >
            <option value="Artwork">Artwork</option>
            <option value="Abstract">Abstract</option>
            <option value="Landscape">Landscape</option>
            <option value="Avatar">Avatar</option>
            <option value="Character">Character</option>
            <option value="Animation">Animation</option>
            <option value="Music">Music</option>
            <option value="Collectibles">Collectibles</option>
          </select>
        </div>
        
        <div className="form-group">
          <label htmlFor="rarity">Rarity</label>
          <select
            id="rarity"
            name="rarity"
            value={nftData.rarity}
            onChange={handleInputChange}
          >
            <option value="common">Common</option>
            <option value="uncommon">Uncommon</option>
            <option value="rare">Rare</option>
            <option value="epic">Epic</option>
            <option value="legendary">Legendary</option>
          </select>
        </div>
        
        <button 
          type="submit" 
          className="create-button"
          disabled={isLoading}
        >
          {isLoading ? 'Creating...' : 'Create NFT'}
        </button>
      </form>
    </div>
  );
};

export default CreateNFT;